import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=b7830378&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=b7830378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7830378",
  null
  
)

export default component.exports